import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import McqNonEditQB from "../ContentManagement/QuestionbankCM/ViewQuestion/McqNonEditQB";
import ImgNonEditQB from "../ContentManagement/QuestionbankCM/ViewQuestion/ImgNonEditQB";
import axios from "../axios";
import CrossAttachmentAssessment from "./QuestionEditCreate/CrossAttachmentAssessment";
import { Book, BookOpenTextIcon, Lightbulb, X } from "lucide-react";
import assets from "../assets/assets";

const QuestionPopup = ({
  b4sid = null,
  setB4SQuestionId,
  qId = null,
  setQuestion,
}) => {
  const [data, setData] = useState([]);
  const [b4squestion, setB4squestion] = useState([]);

  const { state } = useLocation();

  const handleQB = async () => {
    try {
      let res = null;
      if (b4sid) {
        res = await axios.get(`/api/v1/b4sQuestion/get/${b4sid}`);
        setB4squestion(() => [res.data.data]);
      } else if (qId) {
        res = await axios.get(`/api/v1/questionbank/getById/${qId}`);
        setData(res.data.data?.questions);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleQB();
  }, []);

  return (
    <div className=" successful_preview_transprant_body ">
      <div
        className=" p-2 successful_preview_container shadow position-relative"
        style={{
          width: "50vw",
          height: "90vh",
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        {b4squestion?.length > 0 &&
          b4squestion.map((data, index) => {
            if (data.options) {
              return (
                <>
                  {/* <div className="d-flex align-items-center  w-100">
                    <div className="m-0 mt-3 p-3 question_box_container w-100">
                      <div className=" d-flex align-items-center hw_default_dropdown_box_size w-100">
                        <span>Question : {data.title} </span>
                      </div>
                      <div className="mt-3 d-flex gap-2 justify-content-between w-100">
                        <div style={{ width: "50%" }}>
                          <div className="hw_default_dropdown_box_size mb-3">
                            Book Name :{" "}
                            {data?.book_id?.name || data?.book?.name}
                          </div>
                          <div className="hw_default_dropdown_box_size mb-3">
                            Chapter Name :{" "}
                            {data?.chapter_id?.chapterName ||
                              data?.chapter?.chapterName}
                          </div>
                          <div className="hw_default_dropdown_box_size mb-3">
                            {data?.skill_id?.name || data?.skill?.name} |{" "}
                            {data?.difficulty_level?.name} |{" "}
                            {data?.type_id?.name || data?.type?.name}
                          </div>
                        </div>
                        {data?.attachments?.length > 0 && (
                          <div style={{ width: "50%", position: "relative" }}>
                            <div
                              className="hw_default_dropdown_box_size"
                              style={{ height: "200px" }}
                            >
                              {data?.attachments?.map((attachment, index) => (
                                <CrossAttachmentAssessment
                                  attachment={attachment}
                                />
                              ))}
                            </div>
                            <img
                              src="./images/linkOpen.svg"
                              width="30"
                              height="30"
                              alt=""
                              style={{
                                position: "absolute",
                                bottom: "0px",
                                right: "0px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                      {data?.options.length > 0 &&
                        data?.options.map((obj) => (
                          <div className="d-flex mb-3 mt-3">
                            <div className="hw_question_no me-2">{obj.key}</div>
                            <div className="hw_mcq_option_box">{obj.value}</div>
                          </div>
                        ))}

                      <div className=" ml-3 mb-3 ">
                        <div className="hw_select_ans ml-2 mb-2">
                          Correct answer
                        </div>
                        {data?.correct_answers.length > 0 &&
                          data?.correct_answers.map((obj) => (
                            <div className="d-flex mb-3 ml-1 p-0 ">
                              <div className="w-100">
                                <div className="w-100">
                                  <div className="hw_mcq_answer_option_box w-100">
                                    <span className="col-1 px-5 d-flex align-items-center justify-content-center select_option_dropdown   ">
                                      {obj.option_key}
                                    </span>
                                    <div className="col-11 hw_correct_ans_option ">
                                      {obj.value}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-3">
                                  <div className="hw_select_ans ml-2 mb-2">
                                    Reason for correct answer
                                  </div>
                                  <div className="w-100">
                                    <div className="hw_mcq_option_box mt-2 ">
                                      {obj?.reason_for_answer?.explanation}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div> */}
                  <div className="h-100 w-100">
                    <div
                      className="p-3"
                      style={{
                        width: "100%",
                        height: "140px",
                        backgroundColor: " #ffebd3",
                      }}
                    >
                      <div
                        className="d-flex align-items-center justify-content-end "
                        onClick={(e) => {
                          setB4SQuestionId(null);
                          setQuestion(null);
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={assets.closeIcon}
                          alt=""
                          style={{ width: "28px", height: "28px" }}
                          onClick={(e) => {
                            setB4SQuestionId(null);
                            setQuestion(null);
                          }}
                        />
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={assets.LightBulbIcon}
                          alt=""
                          style={{ width: "26px", height: "26px" }}
                        />
                        <span className="poppins-semibold">{data.title} </span>
                        {data?.attachments?.length > 0 && (
                          <div style={{ width: "10%" }}>
                            <div
                              className="hw_default_dropdown_box_size"
                              style={{ height: "30px" }}
                            >
                              {data?.attachments?.map((attachment, index) => (
                                <CrossAttachmentAssessment
                                  attachment={attachment}
                                />
                              ))}
                            </div>
                            {/* <img
                              src="./images/linkOpen.svg"
                              width="30"
                              height="30"
                              alt="attachment"
                            /> */}
                          </div>
                        )}
                      </div>
                      <div className="d-flex align-items-center  gap-5 ms-1">
                        <div className="d-flex align-items-center gap-2 mt-3">
                          <Book size={20} color="#161d2d" />
                          <span className="poppins-semibold">
                            {data?.book_id?.name || data?.book?.name}
                          </span>
                        </div>
                        <div className="d-flex align-items-center gap-2 mt-3">
                          <img
                            src={assets.OpenBook}
                            alt=""
                            style={{ width: "26px", height: "26px" }}
                          />
                          <span className="poppins-semibold">
                            {data?.chapter_id?.chapterName ||
                              data?.chapter?.chapterName}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="mt-2 orange-scrollBar"
                      style={{
                        width: "100%",
                        backgroundColor: "#f8f9fb",
                        maxHeight: "510px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div className="px-5 py-1">
                        {" "}
                        {data?.options.length > 0 &&
                          data?.options.map((obj) => (
                            <div className="d-flex flex-column mb-3 gap-1 mt-3">
                              <div className=" me-2 poppins-semibold">
                                {obj.key}
                              </div>
                              <div
                                className="hw_mcq_option_box"
                                style={{ width: "80%" }}
                              >
                                {obj.value}
                              </div>
                            </div>
                          ))}
                        <div className="mb-3 ">
                          <span className="poppins-semibold">
                            Correct answer
                          </span>
                          {data?.correct_answers.length > 0 &&
                            data?.correct_answers.map((obj) => (
                              <div className="d-flex mb-3  p-0 ">
                                <div className="w-100">
                                  <div className=" w-100 d-flex align-items-center gap-2">
                                    <span className=" poppins-semibold ">
                                      {obj.option_key}
                                    </span>
                                    <div className="poppins-semibold">
                                      {obj.value}
                                    </div>
                                  </div>

                                  <div className="mt-3">
                                    <span className="poppins-semibold mb-2">
                                      Reason for correct answer
                                    </span>
                                    <div className="w-100">
                                      <p className="">
                                        {obj?.reason_for_answer?.explanation}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            } else {
              return <ImgNonEditQB data={data} questionNo={index} />;
            }
          })}
        {data?.length > 0 &&
          data.map((data, index) => {
            if (data.options) {
              return (
                <div className="d-flex align-items-center  w-100">
                  <div className="m-0 mt-3 p-3 question_box_container w-100">
                    <div className=" d-flex align-items-center hw_default_dropdown_box_size w-100">
                      <span>Question : {data.title} </span>
                    </div>
                    <div className="mt-3 d-flex gap-2 justify-content-between w-100">
                      <div style={{ width: "50%" }}>
                        <div className="hw_default_dropdown_box_size mb-3">
                          Book Name :{" "}
                          {data?.book_id?.bookName || data?.book?.bookName}
                        </div>
                        <div className="hw_default_dropdown_box_size mb-3">
                          Chapter Name :{" "}
                          {data?.chapter_id?.chapterName ||
                            data?.chapter?.chapterName}
                        </div>
                        <div className="hw_default_dropdown_box_size mb-3">
                          {data?.skill_id?.name || data?.skill?.name} |{" "}
                          {data?.difficulty_level?.name} |{" "}
                          {data?.type_id?.name || data?.type?.name}
                        </div>
                      </div>
                      {data?.attachments?.length > 0 && (
                        <div style={{ width: "50%", position: "relative" }}>
                          <div
                            className="hw_default_dropdown_box_size"
                            style={{ height: "200px" }}
                          >
                            {data?.attachments?.map((attachment, index) => (
                              <CrossAttachmentAssessment
                                attachment={attachment}
                              />
                            ))}
                          </div>
                          <img
                            src="./images/linkOpen.svg"
                            width="30"
                            height="30"
                            alt=""
                            style={{
                              position: "absolute",
                              bottom: "0px",
                              right: "0px",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    {data?.options.length > 0 &&
                      data?.options.map((obj) => (
                        <div className="d-flex mb-3 mt-3">
                          <div className="hw_question_no me-2">{obj.key}</div>
                          <div className="hw_mcq_option_box">{obj.value}</div>
                        </div>
                      ))}

                    <div className=" ml-3 mb-3 ">
                      <div className="hw_select_ans ml-2 mb-2">
                        Correct answer
                      </div>
                      {data?.correct_answers.length > 0 &&
                        data?.correct_answers.map((obj) => (
                          <div className="d-flex mb-3 ml-1 p-0 ">
                            <div className="w-100">
                              <div className="w-100">
                                <div className="hw_mcq_answer_option_box w-100">
                                  <span className="col-1 px-5 d-flex align-items-center justify-content-center select_option_dropdown   ">
                                    {obj.option_key}
                                  </span>
                                  <div className="col-11 hw_correct_ans_option ">
                                    {obj.value}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-3">
                                <div className="hw_select_ans ml-2 mb-2">
                                  Reason for correct answer
                                </div>
                                <div className="w-100">
                                  <div className="hw_mcq_option_box mt-2 ">
                                    {obj?.reason_for_answer?.explanation}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="d-flex align-items-center  w-100">
                  <div className="m-0 mt-3 p-3 question_box_container w-100">
                    <div className=" d-flex align-items-center hw_default_dropdown_box_size w-100">
                      <span>Question : {data.title} </span>
                    </div>
                    <div className="mt-3 d-flex gap-2 justify-content-between w-100">
                      <div style={{ width: "50%" }}>
                        <div className="hw_default_dropdown_box_size mb-3">
                          Book Name :{" "}
                          {data?.book_id?.bookName || data?.book?.bookName}
                        </div>
                        <div className="hw_default_dropdown_box_size mb-3">
                          Chapter Name :{" "}
                          {data?.chapter_id?.chapterName ||
                            data?.chapter?.chapterName}
                        </div>
                        <div className="hw_default_dropdown_box_size mb-3">
                          {data?.skill_id?.name || data?.skill?.name} |{" "}
                          {data?.difficulty_level?.name} |{" "}
                          {data?.type_id?.name || data?.type?.name}
                        </div>
                      </div>
                      {data?.attachments?.length > 0 && (
                        <div style={{ width: "50%", position: "relative" }}>
                          <div
                            className="hw_default_dropdown_box_size"
                            style={{ height: "200px" }}
                          >
                            {data?.attachments?.map((attachment, index) => (
                              <CrossAttachmentAssessment
                                attachment={attachment}
                              />
                            ))}
                          </div>
                          <img
                            src="./images/linkOpen.svg"
                            width="30"
                            height="30"
                            alt=""
                            style={{
                              position: "absolute",
                              bottom: "0px",
                              right: "0px",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="mt-3  mb-3">
                      {data.correct_answers?.length > 0 &&
                        data.correct_answers.map((obj) => (
                          <div>
                            <div className="hw_select_ans ml-2 mb-2">
                              Reason for correct answer
                            </div>
                            <div className="hw_correct_option_box w-100">
                              {obj?.reason_for_answer?.explanation}
                            </div>
                            {obj?.reason_for_answer?.attachment && (
                              <div className="mt-2 d-flex justify-content-end w-100">
                                <CrossAttachmentAssessment
                                  attachment={obj?.reason_for_answer.attachment}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              );
            }
          })}
      </div>
    </div>
  );
};

export default QuestionPopup;
